/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resultCardId } from '../../utils/string';
import { HigherLevelStatuses } from '../../constants/storyStatusTypes';
import KanbanCard from '../Kanban/kanbanCard';
import {
  filterEpicsByPropsProduct,
  filterResultsByPropsProduct
} from '../../selectors/workPackageSelector';

const ScopeTab = ({ epics, allWorkPackages, showDeleted }) => (
  <div className="scope-tab col-sm-12">
    <div className="col-sm-12 epic-columns">
      {epics.map((epic, index) => {
        const upperCaseSnakeCaseState = epic.state
          .replace(' ', '_')
          .toUpperCase();
        const featureState = HigherLevelStatuses[upperCaseSnakeCaseState];
        const headerClassName = `${featureState
          .toLowerCase()
          .replace(' ', '-')}-header`;
        const bodyClassName = `${featureState
          .toLowerCase()
          .replace(' ', '-')}-body`;
        return (
          <div
            className="epic-column"
            key={epic.id}
            style={{ zIndex: `${1000 - index}` }}
          >
            <div className={`sprint-header ${headerClassName}`}>
              <a href="#">
                {resultCardId(epic)} - {epic.short_name}
              </a>
            </div>
            <div className={`column-body ${bodyClassName}`}>
              {allWorkPackages
                .filter((wp) => wp.parent_id === epic.id)
                .map((result, wpIndex) => {
                  if (!result.deleted_at || (showDeleted && result.deleted_at))
                    return (
                      <div key={result.id} className="epic-card">
                        <KanbanCard index={wpIndex} result={result} noHolon />
                      </div>
                    );
                })}
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

ScopeTab.propTypes = {
  product: PropTypes.object.isRequired,
  epics: PropTypes.array,
  allWorkPackages: PropTypes.array
};

const mapStateToProps = (state, ownProps) => ({
  epics: filterEpicsByPropsProduct(state, ownProps),
  allWorkPackages: filterResultsByPropsProduct(state, ownProps),
  showDeleted: state.trashReducer.showTrash
});

export default connect(mapStateToProps)(ScopeTab);
